module.exports = __webpack_public_path__ + "img/PTransmision.0689ebfd.png";